import React from 'react';
import { Box, Text } from '@tonic-ui/react';

export const Footer = (): JSX.Element => {
  return (
    <Box backgroundColor="#000000" fontFamily="opensans" color="#939393">
      <Text textAlign="right" paddingRight="80px" paddingTop="31px" paddingBottom="28px">
        © 2023 Trend Micro Incorporated. All rights reserved.
      </Text>
    </Box>
  );
};

Footer.displayName = 'Footer';
